export default __webpack_public_path__ + "static/media/screenshot.32ae782e.webp";